// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container {
  width: 200px;
  height: 100%;
  background-color: #3ba0e9;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: width 0.3s ease;
}
.sidebar-container__logo {
  width: 100%;
  display: flex;
  justify-content: space-around;
  color: white;
  padding: 10px;
  height: 65px;
  background-color: #027da6;
  align-items: center;
}
.sidebar-container__logo--image img {
  display: inline-block;
  object-fit: contain;
}
.sidebar-container__logo--menu svg {
  display: inline-block;
  height: 22px !important;
  width: 22px !important;
  cursor: pointer;
}
.sidebar-container__item {
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 50px;
  padding: 10px;
  cursor: pointer;
}
.sidebar-container__item svg {
  display: inline-block !important;
  height: 22px !important;
  width: 22px !important;
}
.sidebar-container__item p {
  margin: 10px 0;
}
.sidebar-container__item:hover {
  background-color: #495663;
}
.sidebar-container__item-selected {
  background-color: #495663;
}

.sidebar-responsive {
  width: 80px !important;
}

.sales-data-report__timezones--time {
  margin-top: 20px;
  border-color: #fff !important;
  color: #fff;
}

.fllowup-data-report__timezones--time {
  margin-top: 20px;
  border-color: #6366F1 !important;
  background-color: #6366F1;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/styles.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EAEA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AAAJ;AAEI;EACI,WAAA;EACA,aAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAAR;AAGY;EACI,qBAAA;EACA,mBAAA;AADhB;AAMY;EACI,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AAJhB;AASI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AAPR;AASQ;EACI,gCAAA;EACA,uBAAA;EACA,sBAAA;AAPZ;AAUQ;EACI,cAAA;AARZ;AAWQ;EACI,yBAAA;AATZ;AAaI;EACI,yBAAA;AAXR;;AAeA;EACI,sBAAA;AAZJ;;AAeA;EACI,gBAAA;EACA,6BAAA;EACA,WAAA;AAZJ;;AAeA;EACI,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;AAZJ","sourcesContent":[".sidebar-container{\n    width: 200px;\n    height: 100%;\n    // height: 100vh;\n    background-color: #3ba0e9;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    transition: width 0.3s ease;\n\n    &__logo{\n        width: 100%;\n        display: flex;\n        justify-content: space-around;\n        color: white;\n        padding: 10px;\n        height: 65px;\n        background-color: #027da6;\n        align-items: center;\n\n        &--image{\n            img{\n                display: inline-block;\n                object-fit: contain;\n            }\n        }\n\n        &--menu{\n            svg{\n                display: inline-block;\n                height: 22px !important;\n                width: 22px !important;\n                cursor: pointer;\n            }\n        }\n    }\n\n    &__item{\n        width: 100%;\n        color: white;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        min-height: 50px;\n        padding: 10px;\n        cursor: pointer;\n\n        svg{\n            display: inline-block !important;\n            height: 22px !important;\n            width: 22px !important;\n        }\n\n        p{\n            margin: 10px 0;\n        }\n\n        &:hover{\n            background-color: #495663;\n        }\n    }\n\n    &__item-selected{\n        background-color: #495663;\n    }\n}\n\n.sidebar-responsive{\n    width: 80px !important;\n}\n\n.sales-data-report__timezones--time {\n    margin-top:20px ;\n    border-color: #fff !important;\n    color: #fff;\n}\n\n.fllowup-data-report__timezones--time {\n    margin-top:20px ;\n    border-color: #6366F1 !important;\n    background-color: #6366F1;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
